import { css } from "@emotion/css";

import { _Avatar } from "./_Avatar";
import { AvatarBaseProps } from "./types";
import { BrandAsset } from "../../foundations/brand-assets/BrandAsset";

type Props = Pick<AvatarBaseProps, "size" | "testID" | "displayVerifiedBadge"> &
  object;

export function CertnAvatar({ testID = "certn-avatar", ...props }: Props) {
  return (
    <_Avatar
      {...props}
      backgroundColor="surface-base"
      testID={testID}
      className={styles.avatar}
    >
      <BrandAsset
        brand="certn"
        type="logo"
        style={{ width: "57%", height: "57%" }}
      />
    </_Avatar>
  );
}

const styles = {
  avatar: css({
    boxShadow: "inset 0 0 0 1px var(--border-base)",
  }),
};
